<template>
  <div class="my-order" ref="container">
    <div class="header bg-color-red">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="text">
          <div class="name">门店订单信息</div>
          <div>
            累计订单：{{ orderData.order_count || 0 }}
			总消费：￥{{ orderData.sum_price || 0 }}
          </div>
        </div>
        <div class="pictrue"><img src="@assets/images/orderTime.png" /></div>
	  </div>
    </div>
    <div class="nav acea-row row-around">
	  <div
	    class="item"
	    :class="{ on: type === 999 }"
	    @click="$router.replace({ path: '/user/scan_order/999' })"
	  >
	    <div>全部</div>
	    <div class="num">{{ orderData.total_count || 0 }}</div>
	  </div>
      <div
        class="item"
        :class="{ on: type === 0 }"
        @click="$router.replace({ path: '/user/scan_order/0' })"
      >
        <div>待付款</div>
        <div class="num">{{ orderData.unpaid_count || 0 }}</div>
      </div>
      <div
        class="item"
        :class="{ on: type === 5 }"
        @click="$router.replace({ path: '/user/scan_order/5' })"
      >
        <div>待核销</div>
        <div class="num">{{ orderData.write_count || 0 }}</div>
      </div>
      <div
        class="item"
        :class="{ on: type === 4 }"
        @click="$router.replace({ path: '/user/scan_order/4' })"
      >
        <div>已完成</div>
        <div class="num">{{ orderData.complete_count || 0 }}</div>
      </div>
	  <div
	    class="item"
	    :class="{ on: type === -2 }"
	    @click="$router.replace({ path: '/user/scan_order/-2' })"
	  >
	    <div>已退款</div>
	    <div class="num">{{ orderData.y_refund_count || 0 }}</div>
	  </div>
    </div>
    <div class="list">
	  <!-- 搜索 -->
	  <form @submit.prevent="search()">
		  <div class="search-wapper" v-if="type == 999">
			<input type="text" v-model="keyword" placeholder="搜索订单号">
			<span class="iconfont icon-sousuo" @click="search()"></span>
		  </div>
	  </form>
      <div class="item" v-for="order in orderList" :key="order.id">
        <div class="title acea-row row-between-wrapper">
          <div class="acea-row row-middle">
            订单号：{{ order.order_id }}
          </div>
          <!-- <div class="font-color-red">{{ getStatus(order) }}</div> -->
        </div>
        <div @click="$router.push({ path: '/user/scan_order_details/' + order.order_id + '?uid=' + order.uid })">
          <div
            class="item-info acea-row row-between row-top"
            v-for="cart in order.cartInfo"
            :key="cart.id"
          >
            <div class="pictrue">
              <img
                :src="cart.productInfo.image"
                v-if="
                  cart.combination_id === 0 &&
                    cart.bargain_id === 0 &&
                    cart.seckill_id === 0
                "
              />
              <img
                :src="cart.productInfo.image"
                v-else-if="cart.combination_id > 0"
              />
              <img
                :src="cart.productInfo.image"
                v-else-if="cart.bargain_id > 0"
              />
              <img
                :src="cart.productInfo.image"
                v-else-if="cart.seckill_id > 0"
              />
            </div>
            <div class="text acea-row row-between">
              <div class="name line2">
                {{ cart.productInfo.store_name }}
              </div>
              <div class="money">
                <div>
                  ￥{{
                    cart.productInfo.attrInfo
                      ? cart.productInfo.attrInfo.price
                      : cart.productInfo.price
                  }}
                </div>
                <div>x{{ cart.cart_num }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="totalPrice">
          共{{ order.cartInfo.length || 0 }}件商品，总金额
          <span class="money font-color-red">￥{{ order.pay_price }}</span>
        </div>
        <div class="bottom acea-row row-right row-middle">
          <template
            v-if="order._status._type === 0 || order._status._type == 9"
          >
            <div class="bnt cancelBnt" @click="cancelOrder(order)">
              取消订单
            </div>
          </template>
          <template v-if="order._status._type === 0">
            <div class="bnt bg-color-red" @click="paymentTap(order)">
              立即付款
            </div>
          </template>
		  <!-- <template v-if="order.is_contract">
		    <div
		      class="bnt bg-color-red"
		      @click="$router.push({ path: '/order/sign/' + order.order_id })"
		    >
		      查看合同
		    </div>
		  </template> -->
          <template v-if="order._status._type === 1 || order._status._type === 9">
            <div
              class="bnt bg-color-red"
              @click="$router.push({ path: '/user/scan_order_details/' + order.order_id + '?uid=' + order.uid })"
            >
              查看详情
            </div>
          </template>
          <template v-if="order._status._type === 4">
            <div
              class="bnt bg-color-red"
              @click="$router.push({ path: '/user/scan_order_details/' + order.order_id + '?uid=' + order.uid })"
            >
              查看订单
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="noCart" v-if="orderList.length === 0 && page > 1">
      <div class="pictrue"><img src="@assets/images/noOrder.png" /></div>
    </div>
	<!-- <div class="footer-scan-btn-wapper"> -->
	<div class="footer-scan-btn-wapper" v-if="iswechat">
		<div class="footer-scan-btn" @click="openQRCode(1)">扫码退款</div>
		<!-- <div
		  class="footer-scan-btn"
		  onclick="location.href  = '/user/scan_goods'"
		>扫码添加商品</div> -->
		<div class="refund-mask mask" v-if="isRefundMask">
			<div class="refund-Popup">
				<div class="refund-Popup-title">申请退款</div>
				<div class="refund-radio" v-if="refund_info.typeinfo.length > 0">
					<div class="refund-radio-for" v-for="(item,key) in refund_info.typeinfo">
						<input
						  type="radio"
						  name="refund_type"
						  :value="item.value"
						  :id="'type_'+item.value"
						  :checked="item.is_default"
						  @change="radioChange(item.value)"
						>
						<label :for="'type_'+item.value"></label>
						<span>{{ item.label }}</span>
					</div>
				</div>
				<div class="refund-price">
					退款金额：<input type="number" @blur="radioBlur()" v-model="refund_price" :disabled="isPrice" >
				</div>
				<div class="refund-btn-wapper">
					<button class="refund-btn" @click="SubmitRefund()">提交</button>
					<button class="refund-btn cancel" @click="isRefundMask = false">取消</button>
				</div>
			</div>
		</div>
	</div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
    <Payment
      v-model="pay"
      :types="payType"
      @checked="toPay"
      :balance="userInfo.now_money"
    ></Payment>
    <GeneralWindow
      :generalActive="generalActive"
      @closeGeneralWindow="closeGeneralWindow"
      :generalContent="generalContent"
    ></GeneralWindow>
  </div>
</template>
<script>
import { cashierOrderData, cashierOrderList, cashierOrderScan,cashierRefundInfo,cashierRefund, cashierOrderCancel } from "@api/order";
import {
  cancelOrderHandle,
  payOrderHandle,
  takeOrderHandle
} from "@libs/order";
import Loading from "@components/Loading";
import Payment from "@components/Payment";
import { mapGetters } from "vuex";
import {  parseQuery } from "@utils";
import { wechatEvevt } from "@libs/wechat";
import GeneralWindow from "@components/GeneralWindow";
import Vue from "vue";
import cookie from "@utils/store/cookie";

const STATUS = [
  "待付款",
  "待发货",
  "待收货",
  "待评价",
  "已完成",
  "",
  "",
  "",
  "",
  "待付款"
];
 
const NAME = "ScanOrderList";

export default {
  name: NAME,
  data() {
    return {
	  iswechat: this.$wechat.isWeixin(),
      offlinePayStatus: 2,
      orderData: {},
      type: parseInt(this.$route.params.type) || 0,
      page: 1,
      limit: 20,
	  keyword: "",//搜索
      loaded: false,
      loading: false,
      orderList: [],
      pay: false,
      payType: [ "alipay", "weixin", "offline"],
      from: this.$wechat.isWeixin()? "weixin" : "weixinh5",
      generalActive: false,
      generalContent: {
        promoterNum: "",
        title: ""
      },
	  //扫码退款
	  verify_code: "",
	  isRefundMask: false,
	  refund_info: {},
	  refund_type: 1,
	  refund_price: "",
	  fixed_price: "",
	  isPrice: true
    };
  },
  components: {
    Loading,
    Payment,
    GeneralWindow
  },
  computed: mapGetters(["userInfo"]),
  watch: {
    $route(n) {
      if (n.name === NAME) {
        const type = parseInt(this.$route.params.type) || 0;
        if (this.type !== type) {
          this.changeType(type);
        }
        this.getOrderData();
      }
    }
  },
  mounted() {
    this.getOrderData();
    this.getOrderList();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getOrderList();
    });
  },
  methods: {
	//扫码
	openQRCode: function(type) {
	  let that = this;
	  wechatEvevt("scanQRCode", {
	    needResult: 1,// 默认为0，扫描结果由微信处理，1则直接返回扫描结果
	    onlyFromCamera: false,
		scanType: ["qrCode", "barCode"]// 可以指定扫二维码还是一维码，默认二者都有
	  }).then(res => {
	      if (res.resultStr) {
			 console.log('res.resultStr='+res.resultStr);
			if(res.resultStr.includes(',')){
			    that.verify_code = res.resultStr.split(',')[1];        
			}else{
				that.verify_code = res.resultStr;
			}
			that.scanRefund(type);
	      } else that.$dialog.error("没有扫描到什么！");
	  }).catch(res => {
	      console.log('catch='+res.is_ready);
	      if (res.is_ready) {
	        res.wx.scanQRCode({
	          needResult: 1,
	          onlyFromCamera: false,
	          success: function(res) {
				 console.log('catch res.resultStr='+res.resultStr);
				if (res.resultStr) {
				  if(res.resultStr.includes(',')){
				      that.verify_code = res.resultStr.split(',')[1];        
				  }else{
				  	that.verify_code = res.resultStr;
				  }
				  that.scanRefund(type);
				} else that.$dialog.error("没有扫描到什么！");
	          },
	          fail: function(res) {
				console.log('fail'+res.is_ready);
				console.log('fail_errMsg'+res.errMsg);
	            if (res.errMsg == "scanQRCode:permission denied") {
	              that.$dialog.error("没有权限");
	            }
	          }
	        });
	      }
	  });
	},
	//扫码申请退款type=1
	scanRefund(type){
		let that = this;
		if (!that.verify_code) return this.$dialog.error("请扫描退款码");
		cashierRefundInfo(that.verify_code,type).then(res => {
			that.isRefundMask = true;
			that.refund_info = res.data;
			that.refund_price = res.data.refund_price;
			that.fixed_price = res.data.refund_price;
		}).catch(err => {
			that.$dialog.error(err.msg);
		});
	},
	radioChange(type){
		console.log(type);
		if(type == 2){
			this.isPrice = false;
			this.refund_type = 2;
		}else{
			this.isPrice = true;
			this.refund_type = 1;
			this.refund_price = this.fixed_price;
		}
	},
	radioBlur(){
		document.body.scrollTop = 0;
	},
	//提交退款
	SubmitRefund(){
		let that = this,
		  data = {
			  order_id: that.refund_info.order_id,
			  price: that.refund_price,
			  type : that.refund_type
		  };
		that.$dialog.confirm({
		  mes: "确认退款吗？",
		  opts: [
			{
			  txt: "取消",
			  color: false
			},
		    {
		      txt: "确认",
		      color: true,
		      callback: () => {
				that.isRefundMask = false;
				that.$dialog.loading.open("加载中");
		        cashierRefund(data).then(res => {
					that.$dialog.loading.close();
		        	that.$dialog.success(res.msg);
		        }).catch(err => {
					that.$dialog.loading.close();
		        	that.$dialog.error(err.msg);
		        });
		      }
		    }
		  ]
		});
	},
    setOfflinePayStatus: function(status) {
      var that = this;
      that.offlinePayStatus = status;
      if (status === 1) {
        if (that.payType.indexOf("offline") < 0) {
          that.payType.push("offline");
        }
      }
    }, 
    setYuePayStatus: function(status) {
      var that = this;
      that.yuePayStatus = status;
      if (status === 1) {
        if (that.payType.indexOf("yue") < 0) {
          that.payType.push("yue");
        }
      }
    },
    getOrderData() {
      cashierOrderData().then(res => {
        this.orderData = res.data;
      });
    },
    closeGeneralWindow(msg) {
      this.generalActive = msg;
      this.reload();
      this.getOrderData();
    },
    reload() {
      this.changeType(this.type);
    },
    changeType(type) {
      this.type = type;
      this.orderList = [];
      this.page = 1;
      this.loaded = false;
      this.loading = false;
      this.getOrderList();
    },
	//搜索订单号
	search(){
		this.orderList = [];
		this.page = 1;
		this.loaded = false;
		this.loading = false;
		this.getOrderList();
	},
    getOrderList() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      const { page, limit, type, keyword } = this;
      cashierOrderList({
        page,
        limit,
        status: type == 999 ? '' : type,
		keyword
      }).then(res => {
        this.orderList = this.orderList.concat(res.data);
        this.page++;
        this.loaded = res.data.length < this.limit;
        this.loading = false;
      });
    },
    getStatus(order) {
      return STATUS[order._status._type];
    },
    cancelOrder(order) {
    	let that = this,
    	  data = {
    		order_id: order.order_id,
    		uid: order.uid
    	  };
    	that.$dialog.confirm({
    	  mes: "确认取消吗？",
    	  opts: [
			{
			  txt: "取消",
			  color: false
			},
    	    {
    	      txt: "确认",
    	      color: true,
    	      callback: () => {
    			that.$dialog.loading.open("加载中");
    			cashierOrderCancel(data).then(res => {
    				that.$dialog.loading.close();
    				that.$dialog.success(res.msg);
    				that.$router.go(0);
    			}).catch(err => {
    				that.$dialog.loading.close();
    				that.$dialog.error(err.msg);
    			});
    	      }
    	    }
    	  ]
    	});
    },
    paymentTap: function(order) {
      var that = this;
      if (
        !(
          order.combination_id > 0 ||
          order.bargain_id > 0 ||
          order.seckill_id > 0
        )
      ) {
        that.setOfflinePayStatus(order.offlinePayStatus);
        that.setYuePayStatus(order.yuePayStatus);
      }
      this.pay = true;
      this.toPay = type => {
		var data = {
			  uid: order.uid,
			  uni: order.order_id,
			  paytype: type
			};
        cashierOrderScan(data).then(res => {
			var data = res.data;
			switch (data.status) {
				case "ORDER_EXIST":
				case "EXTEND_ORDER":
				case "PAY_DEFICIENCY":
				case "PAY_ERROR":
				  that.$dialog.toast({ mes: res.msg });
				  break;
				case "SUCCESS":
				  that.$dialog.success(res.msg);
				  break;
				case "WECHAT_PAY":
				case "ALIPAY_H5_PAY":
				  that.$router.push('/user/pay_code/' + order.order_id + '/' + order.uid + '?code_url=' + data.result.code_url);		  
				  break;
			}
            const type = parseInt(this.$route.params.type) || 0;
            that.changeType(type);
            that.getOrderData();
        }).catch(err => {
            that.$dialog.error(err.msg);
        });
      };
    },
    toPay() {}
  }
};
</script>

<style scoped>
.search-wapper{
	width: 100%;
	background-color: #fff;
	border-radius: 15px;
	padding: 0.1rem 0.1rem 0.1rem 0.2rem;
	display: flex;
	justify-content: left;
	align-items: center;
	margin-bottom: 0.14rem;
}
.search-wapper .iconfont{
	margin-right: 0.1rem;
	color: #777;
}
.search-wapper input{
	width: 100%;
}
.my-order .list{
	margin-bottom: 1.2rem;
}
.noCart {
  margin-top: 0.17rem;
  padding-top: 0.1rem;
}

.noCart .pictrue {
  width: 4rem;
  height: 3rem;
  margin: 0.7rem auto 0.5rem auto;
}

.noCart .pictrue img {
  width: 100%;
  height: 100%;
}
.footer-scan-btn-wapper{
	position: fixed;
	left: 0;
	bottom: 0;
	background-color: #fff;
	width: 100%;
	padding: 0.2rem 0;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	box-shadow: 0 0 5px 0 #eee;
}
.footer-scan-btn{
	color: #fff;
	background-color: #e93323;
	border-radius: 0.5rem;
	margin-right: 0.2rem;
	padding: 0.1rem 0.3rem;
}
.my-order .list .item .bottom{
	height: auto;
}
.my-order .list .item .bottom .bnt{
	margin: 0.2rem 0;
}
.mask {
	width: 100%;
	height: 100%;
	background: rgba(0,0,0,0.5);
	display: flex;
	justify-content: center;
	align-items: center;
}
.refund-Popup{
	background-color: #fff;
	width: 80%;
	border-radius: 8px;
}
.refund-Popup-title{
	height: 1rem;
	line-height: 1rem;
	text-align: center;
	border-bottom: 1px solid #ccc;
	font-weight: bold;
	font-size: 0.3rem;
}
.refund-radio{
	padding: 0.2rem;
	display: flex;
	justify-content: center;
	align-items: center;
}
.refund-radio-for{
	position: relative;
	width: 38%;
}
.refund-radio-for span{
	position: absolute;
	left: 0.4rem;
	top: 0.01rem;
	width: 1.5rem;
}
input[type="radio"] {
	width: 0.3rem;
	height: 0.3rem;
	opacity: 0;
}
label {
	position: absolute;
	left: 0;
	top: 0.06rem;
	width: 0.3rem;
	height: 0.3rem;
	border-radius: 50%;
	border: 1px solid #999;
	cursor: pointer;
	display: inline-block;
	margin-right: 0.1rem;
}
input[type="radio"]:checked+label { 
	background-color: #e93323;
	border: 1px solid #e93323;
}
input[type="radio"]:checked+label::after {
	position: absolute;
	content: "";
	width: 0.09rem;
	height: 0.17rem;
	top: 0.02rem;
	left: 0.09rem;
	border: 2px solid #fff;
	border-top: none;
	border-left: none;
	transform: rotate(45deg);
}
.refund-price{
	padding: 0 0.2rem;
	display: flex;
	justify-content: center;
	align-items: center;
}
.refund-price input{
	border: 1px solid #ccc;
	text-indent: 0.2rem;
}
.refund-btn-wapper{
	margin: 0.3rem auto;
	margin-top: 0.5rem;
	display: flex;
	justify-content: center;
	align-items: center;
}
.refund-btn{
	padding: 0.1rem 0.5rem;
	background-color: #e93323;
	color: #fff;
	border-radius: 7px;
	border: 1px solid #e93323;
}
.refund-btn-wapper .cancel{
	margin-left: 0.6rem;
	background-color: #fff;
	color: #e93323;
}
</style>
